/* eslint no-use-before-define: 0 */

const hexToColor = (hex) => {
	let regex = new RegExp();
	if(hex.length === 7) {
		regex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
	}
	else if(hex.length === 4) {
		regex = /^#?([a-f\d]{1})([a-f\d]{1})([a-f\d]{1})$/i;
	}
	else{
		return "MIXIN_ERROR";
	}

	const result = regex.exec(hex);
	if(result) {
		return result
			.filter((s, i) => {
				return i > 0;
			})
			.map((hexnum) => {
				return parseInt(hexnum, 16) * (hexnum.length < 2 ? 17 : 1);
			})
			.concat(1);
	}
	else{
		return getColor();
	}
};

// returns [ r, g, b, a, ]
const getColor = (color) => {
	const fallback = [ 255, 255, 255, 1, ]; //white

	if(!color) {
		return fallback;
	}
	else if(color.constructor === Array) {
		return color.length === 4 ? color : color.concat(1);
	}
	else if(color.indexOf("#") > -1) {
		return hexToColor(color);
	}
	else if(color.indexOf("rgb") > -1 || color.indexOf("rgba") > -1) {
		return color.replace(/ /g, "")
			.replace("rgb(", "")
			.replace("rgba(", "")
			.replace(")", "")
			.split(",");
	}
	else{
		return fallback;
	}
};

const rgba = (...args) => {
	let r = "";

	if(args.length === 1) {
		r = args[0].join(",");
	}
	else if(args.length === 2) {
		r = getColor(args[0]).slice(0,3)
			.concat(args[1]);
	}
	else if(args.length === 3) {
		r = args.concat(1).join(",");
	}
	else if(args.length === 4) {
		r = args.join(",");
	}
	else{
		r = getColor().join(",");
	}

	return "rgba(" + r + ")";
};

const mix = (c1, c2, num = 0.5) => (
	rgba(getColor(c1).map((h, i) => (
		Math.round((num * h) + ((1 - num) * getColor(c2)[i]))
	)))
);

export default {
	tr: (num) => `
		rgba(0,0,0,${num})
	`,
	truncate: () => `
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	`,
	rgba: rgba,
	stretch: () => {
		return `
			position: absolute;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
		`;
	},
	mix: mix,
	darken: (color, num = 0.1) => mix("#000", color, num),
	wh: (size) => `
		width: ${size};
		height: ${size};
	`,
	shadow: (elevation = 1) => ({
		"1": "box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);",
		"2": "box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);",
		"3": "box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);",
		"4": "box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);",
		"5": "box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);",
		"-1": "box-shadow: inset 0 -1px 3px rgba(0,0,0,0.12), inset 0 -1px 2px rgba(0,0,0,0.24);",
	}[elevation]),
	contained: (offset = 0) => `
		position: absolute;
		top: ${offset};
		right: ${offset};
		bottom: ${offset};
		left: ${offset};
	`,
};
